import {InitFormRequestSubmitPolyfill, isFormRequestSubmitPolyfillRequired} from "./form-request-submit-polyfill";

export const InitPolyfills = () => {
  // TODO: The polyfill shouldn't be loaded if it isn't required.
  isFormRequestSubmitPolyfillRequired() && InitFormRequestSubmitPolyfill()
}
